<template>
    <form class="metadata-form" v-if="activeTag">
      <div class="metadata-form__header _flxrcc">
        <span class="_flxgrow1">&nbsp;</span>
        <h1 v-help="docsPath(activeTag.template)">{{ labelForTemplate(activeTag.template) }} Properties</h1>
        <div @click="onCloseTag" class="metadata-form__close _flxgrow1 _flxrce">
          <i class="material-icons">close</i>
        </div>
      </div>
      <ul class="metadata-form__content">
        <template v-if="['quiz', 'quizzes', 'customEmbed', 'singleChoice'].indexOf(template) < 0">
          <li v-for="item in form" :class="template" :key="template + '-' + item.key" :style="{visibility: item.visible}" class="section">
            <label v-if="!(item.type === 'textbox-form')" :for="'meta-form_'+item.key+item.label" v-help.first="item.docPath">{{item.label}}<lang-toggler v-if="item.multilang" :lang="item.value ? item.value.lang : 'de'" @input="item.value.lang = $event" @applyAll="onApplyToAllLangs(item, $event)"/></label>
            <!-- as for now vue does not support dynamic types on v-model, howevet v-model makes it a lot easier to sync form values, so theres the ifs-->
            <input v-if="item.type === 'text' && item.multilang" v-on:blur="updateLangValue(item, $event)" v-model="item.value[item.value.lang]" :id="'meta-form_'+item.key" type="text" :name="item.key" />
            <input v-if="item.type === 'text' && !item.multilang" v-on:blur="updateValue(item, $event)" v-model="item.value" :id="'meta-form_'+item.key" type="text" :name="item.key" />
            <input v-if="item.type === 'checkbox'" v-on:blur="updateValue(item, $event)" v-model="item.value" :id="'meta-form_'+item.key" type="checkbox" :name="item.key" />
            <input v-if="item.type === 'number'" v-on:blur="updateValue(item, $event)" v-model.number="item.value" :id="'meta-form_'+item.key" type="number" :name="item.key" />
            <input v-if="item.type === 'percent'" v-on:blur="updateValue(item, $event)" v-model="item.value" :id="'meta-form_'+item.key" type="text" :name="item.key" />
            <textarea v-if="item.type === 'textarea' && item.multilang" v-on:blur="updateLangValue(item, $event)" v-model="item.value[item.value.lang]" :id="'meta-form_'+item.key" :name="item.key" />
            <textarea v-if="item.type === 'textarea' && !item.multilang" v-on:blur="updateValue(item, $event)" v-model="item.value" :id="'meta-form_'+item.key" :name="item.key" />
            <dot-picker v-if="item.type === 'icon-picker'" v-on:pick="storeMetaData" :modelItem="item" />
            <shape-picker v-if="item.type === 'shape-picker'" v-on:pick="storeMetaData" :modelItem="item" />
            <image-cropper v-if="item.type === 'image-cropper'" v-on:inputImage="saveImage(item, $event)" v-on:deleteImage="deleteImage(item, $event)" :isModal="true" :value="item.value[item.value.lang]" :showImageName="true">
              <div class="image-cropper">
                 <i class="material-icons">add_photo_alternate</i>
              </div>
            </image-cropper>
            <choose-behaviour v-if="item.type === 'choose-behaviour'" v-on:pick="storeMetaData" :modelItem="item" />
            <choose-animation v-if="item.type === 'choose-animation'" v-on:pick="storeMetaData" :modelItem="item" :template="template" />
            <choose-scale-behaviour v-if="item.type === 'choose-scale-behaviour'" v-on:pick="storeMetaData" :modelItem="item" />
            <TextBoxForm v-if="item.type === 'textbox-form'" v-on:pick="storeMetaData" :modelItem="item" v-on:translate="translateText(item)" />
            <option-select v-if="item.type === 'option-select'" v-on:input="updateItemFrom(item, $event)" :modelItem="item" :value="item.value" :options="item.options" />
            <color-scheme-select v-if="item.type === 'color-scheme-select'" v-on:pick="storeMetaData" :modelItem="item" :value="item.value.key" :options="item.options" />
            <align-picker v-if="item.type === 'align-picker'" v-on:pick="storeMetaData" :modelItem="item" :value="item.value" :options="item.options" />
            <button-style-picker v-if="item.type === 'button-style-picker'" v-on:pick="storeMetaData" :modelItem="item" :value="item.value" :options="item.options" />
            <cling-slider v-if="item.type === 'cling-slider'" :showValue="true" v-on:input="updateItemFrom(item, $event)" :value="item.value" :min="item.options.min" :max="item.options.max" />
          </li>
        </template>
        <CustomEmbedForm v-else-if="template === 'customEmbed'" :tag="activeTag" v-bind:key="activeTag && activeTag.id" />
        <EmbedForm v-else-if="template === 'cover'" :tag="activeTag" v-bind:key="activeTag && activeTag.id" />
        <QuizForm v-else-if="template === 'quiz'" :tag="activeTag" v-bind:key="activeTag && activeTag.id" />
        <Quizzes v-else-if="template === 'quizzes'" :tag="activeTag" v-bind:key="activeTag && activeTag.id" />
        <SingleChoiceForm v-else-if="template === 'singleChoice'" :tag="activeTag" v-bind:key="activeTag && activeTag.id" />
      </ul>

    </form>
</template>
<script>

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import QuizForm from './quizForm'
import Quizzes from './quizzes'
import SingleChoiceForm from './singleChoiceForm'
import DotPicker from './dotPicker'
import ShapePicker from './shapePicker'
import AlignPicker from './alignPicker'
import ButtonStylePicker from './buttonStylePicker'
import ClingSlider from './../core/clingSlider'
import TextBoxForm from './textBoxForm'
import ChooseBehaviour from './chooseBehaviour'
import ChooseScaleBehaviour from './chooseScaleBehaviour'
import ImageCropper from './imageCropper/'
import ChooseAnimation from './chooseAnimation'
import CustomEmbedForm from './customEmbedForm'
import OptionSelect from './optionSelect'
import ColorSchemeSelect from './colorSchemeSelect'
import EmbedForm from './embedForm'
import LangToggler from './langToggler'
import { metaDataFormFields, metaDataFormDefaultsFor } from './metadataFormFields'
import { saveScene } from '../../mixins/saveScene.js'


export default {
  name: 'metadata-form',

  data() {
    return {
      template: 'generic',
      selectedAlignment: null,
      form: []
    }
  },

  mixins: [saveScene],

  watch: {
    'selection.tag': 'onTagChange'
  },
  computed: {
    ...mapState(['selection', 'video']),
    activeTag: function () {
      return this.selection.tag ? this.selection.tag : null
    }
  },
  components: {
    QuizForm,
    Quizzes,
    EmbedForm,
    'dot-picker': DotPicker,
    'shape-picker': ShapePicker,
    TextBoxForm,
    ChooseBehaviour,
    ChooseAnimation,
    ChooseScaleBehaviour,
    CustomEmbedForm,
    SingleChoiceForm,
    OptionSelect,
    ColorSchemeSelect,
    AlignPicker,
    ButtonStylePicker,
    ImageCropper,
    LangToggler,
    ClingSlider
  },
  methods: {
    ...mapMutations(['updateMetadata', 'setTemplate']),
    ...mapActions(['storeImage', 'deleteImageFromStore', 'translate']),
    ...mapGetters(['selectedAsset']),
    // update value from an dom event
    updateValue: function (item, e) {
      let target = e.target
      if (target.type === 'checkbox') {
        item.value = target.checked
      }
      this.storeMetaData()
    },
    updateLangValue: function (item, e) {
      console.log("update lang value", item)
      item.value[item.value.lang] = e.target.value
      this.storeMetaData()
    },
    onApplyToAllLangs: function(item, ev) {
      let val = item.value[ev]
      for (const k in item.value) {
        if (k !== 'lang') {
          item.value[k] = val
        }
      }
    },
    // update value from vue event holding the input value
    updateItemFrom(item, value) {
      item.value = value
      this.storeMetaData()
    },
    onChangeTemplate: function (ev) {
      //console.log('onChangeTemplate', ev.target.value)
      this.storeMetaData()
      this.template = ev.target.value
      this.buildForm()
    },
    onTagChange(newVal, oldVal) {
      if (!this.selection.tag) {
        return
      }
      //console.log('onTagChange', newVal, oldVal)
      this.template = this.selection.tag.template || 'generic'
      this.buildForm()
      // this.updateForm(this.activeMeta)
    },
    saveImage(item, val) {
      const that = this
      const asset = this.selectedAsset()
      const imageToStore = {name: `${item.value.lang || 'de'}-${asset.id}-${this.selection.tag.id}`, base64: val}
      this.storeImage(imageToStore).then((imageUrl) => {
          // item.value = imageUrl
          if (typeof item.val === 'string') {
            item.value = imageUrl
          } else {
            item.value[item.value.lang] = imageUrl
          }
          that.storeMetaData()
      });
    },
    deleteImage(item, val) {
      this.deleteImageFromStore({imageUrl: item.value}).then((imageUrl) => {
        console.log('Image deleted')
      });
      if (typeof item.value === 'string') {
        item.value = ""
      } else {
        item.value[item.value.lang] = ""
      }
      this.storeMetaData()
    },
    buildForm() {
      if (!this.selection.tag) {
        return
      }
      this.form.splice(0, this.form.length)

      let fields = metaDataFormFields(this.template)

      if (!fields) {
        return
      }
      //console.log("fields", fields)
      let meta = this.selection.tag.meta
      for (var i = 0; i < fields.length; i++) {
        let f = fields[i]
        // f.languages = this.video.meta.languages
        // merge values from meta, check for backwards compatibility on multilang
        let mfv = meta[f.key]
        if (f.multilang && (typeof mfv === 'string' || !mfv)) {
          mfv = f.value
        }
        // field value not set on meta data but default value available ?
        // then use it as default
    
        if (mfv == null && f.value) {
          mfv = f.value
        }
        this.$set(f, 'value', mfv)
        this.form.push(f)
      }
      //console.log('form values', this.form)
    },
    storeMetaData() {
      //console.log("storeMetaData")
      let newMeta = {}
      for (var i = 0; i < this.form.length; i++) {
        let f = this.form[i]
        newMeta[f.key] = f.value
      }
      this.updateMetadata(newMeta)
      this.selection.tag.template = this.template
    },
    labelForTemplate(template) {
      let hit = metaDataFormDefaultsFor(template)
      return hit ? hit.label : template
    },
    docsPath(template) {
      let hit = metaDataFormDefaultsFor(template)
      return hit ? hit.docs : 'faq/#missing'
    },
    onCloseTag() {
      // see mixin saveScene
      this.saveScene()
    }
  }
}
</script>
